import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

import { BlogListResponse } from '../../interfaces/blog';

const NewsPage = () => {
  const [blogListResponse, setBlogListResponse] = useState<BlogListResponse>();

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const graphql = JSON.stringify({
      query: `query Blogs {
		blogs(orderBy: date_DESC, last: 1000) {
		  date
		  id
		  title
		  mainImage {
			url
		  }
		  rich {
			html
		  }
		}
	  }
	  `,
      variables: {},
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: graphql,
    };

    fetch('https://api-eu-west-2.hygraph.com/v2/clgmiysfd553901t2h4wj8nro/master', requestOptions)
      .then((response) => response.json())
      .then((resultData: BlogListResponse) => {
        setBlogListResponse(resultData);
      });
  }, []);

  return (
    <Layout>
      <article>
        <div className="links top-spacing-big">
          {blogListResponse && blogListResponse.data && (
            <>
              {blogListResponse.data.blogs.map((blog) => (
                <Link className="link news-link" key={blog.id} to={`/news-item/${blog.id}`}>
                  {blog.mainImage?.url && (
                    <img src={blog.mainImage.url} alt={blog.title} className="news-list__image" />
                  )}
                  <span>
                    {new Date(blog.date).toLocaleDateString('uk-UA', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </span>
                  <br />
                  <span>{blog.title}</span>
                </Link>
              ))}
              <Link to={`/news/ukraina-nezlamna-sylna-talanovyta`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/ukraina-nezlamna-sylna-talanovyta/ukraina-nezlamna-sylna-talanovyta-1.jpg"
                  alt="Україна незламна, сильна, талановита"
                />
                <span>“Україна незламна, сильна, талановита”</span>
              </Link>
              <Link to={`/news/den-zakhystu-ditei-2023`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/den-zakhystu-ditei-2023/den-zakhystu-ditei-1.jpeg"
                  alt="День захисту дітей"
                />
                <span>01.06.2023р.</span> <br />
                <span>День захисту дітей</span>
              </Link>
              <Link to={`/news/global-money-week-2023`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/global-money-week-2023/global-money-week-2023-1.png"
                  alt="Global Money Week 2023"
                />
                <span>06.04.2023р.</span> <br />
                <span>Global Money Week 2023</span>
              </Link>
              <Link to={`/news/hodyna-zemli`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/hodyna-zemli/hodyna-zemli-1.jpeg"
                  alt="Година Землі"
                />
                <span>25.03.2023р.</span> <br />
                <span>Година Землі</span>
              </Link>
              <Link to={`/news/yak-maliata-maslianu-sviatkuvaly`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/yak-maliata-maslianu-sviatkuvaly/yak-maliata-maslianu-sviatkuvaly-thumbnail.jpg"
                  alt="Адаптація дітей до умов дошкільного закладу"
                />
                <span>23.02.2023р.</span> <br />
                <span>Як малята Масляну святкували</span>
              </Link>
              <Link to={`/news/laptop-from-the-lego-foundation`} className="link news-link">
                <StaticImage
                  layout="constrained"
                  formats={['auto', 'webp', 'avif']}
                  width={300}
                  height={300}
                  src="../../images/news/laptop-from-the-lego-foundation/laptop-from-the-lego-foundation-1.jpg"
                  alt="Ноутбук від Фонду The LEGO Foundation"
                />
                <span>01.02.2023р.</span> <br />
                <span>Ноутбук від Фонду The LEGO Foundation</span>
              </Link>
            </>
          )}
        </div>
      </article>
    </Layout>
  );
};

export default NewsPage;

export const Head = () => <SEO title="Новинки цікавинки" />;
